import React from 'react'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import moment from 'moment'
import 'dayjs/locale/zh-cn' // 不加日期内部的年月没有汉化
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

export default function createAntdApp(App) {
  return () => (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#046626',
        },
      }}
    >
      <App />
    </ConfigProvider>
  )
}
